// extracted by mini-css-extract-plugin
export var infoItem = "_pb-2";
export var title = "_pb-0";
export var value = "_pb-1";